import {
  getFavSymbolsFromStorage,
  getPriceBoardViewMode,
  getPriceBoardIndexMode,
  getLanguageFromStorage,
  getTabRightModeFromStore,
  getPriceBoardColumnConfigFromStorage,
  getSummarySymbolsFromStorage,
  getTabNameCurrentDisplayFromStorage,
} from "../actions/sharedActions";

import { parseJSON } from "../../helpers/utils";

const _favSymbols = getFavSymbolsFromStorage() ?? [];
const _summarySymbols = getSummarySymbolsFromStorage() ?? [];
const _priceBoardViewMode = getPriceBoardViewMode() ?? "DETAIL";
const _priceBoardIndexMode = getPriceBoardIndexMode() ?? "FULL";
const c_initLanguage = getLanguageFromStorage();
const _tabRightMode = getTabRightModeFromStore();
const _tabNameCurrentDisplay = getTabNameCurrentDisplayFromStorage() ?? [];

const _initPriceBoardColumnConfig = parseJSON(getPriceBoardColumnConfigFromStorage()) ?? {
  updateTime: 0,
  DETAIL: {
    showCode: true,
    showCodeMatch: false,
    showTotalTradedQtty: true,
    showQttyBuy4: true,
    showQttySell4: true,
    showBuyForeignQtty: true,
    showSellForeignQtty: true,
    showRemainForeignQtty: true,
  },
};

const initState = {
  initTime: 0,
  forceUpdateTime: 0,
  language: c_initLanguage && c_initLanguage != "" ? c_initLanguage : "vi",
  tabIsFocus: true,
  sysDate: "",
  startupDate: "",
  tradingDate: "",
  serverTime: 0,
  numberStockTop: 30,
  useCompanyProfile: "",
  useDerivative: "",
  // Cau hinh tham so hien thi mac dinh cho tab ben phai
  sideTab_Type: "",
  sideTab_Code: "",
  // Cau hinh hien thi tab ben phai
  hideTabRight: true,
  autoShowOnSelect: true,
  currentTabRight: "",
  tabRightMode: _tabRightMode && _tabRightMode !== "" ? _tabRightMode : "FLOAT",
  tabRightChilds: [
    { name: "INFO", content: "Chi tiết", contentEn: "Detail" },
    // {name: "ORDER", content: "Đặt lệnh"},
    // {name: "WARNING", content: "Cảnh báo"}
  ],
  // Cau hinh bang gia
  priceBoardIndexMode: _priceBoardIndexMode, // FULL: Hien thi day du; HIDDEN: An; INFO: Hien thi thon tin
  priceBoardViewMode: _priceBoardViewMode, // DETAIL-Detail mode, BOX-Box mode, TOTAL- Total mode
  priceBoardSortConfig: { type: "asc", column: "code", dataType: "" },
  priceBoardFavSymbols: _favSymbols,
  priceBoardSummarySymbols: _summarySymbols,
  priceBoardIsOddlot: false,
  //du lieu cua tung ma chung khoan
  getInfoItemCode: { type: "", code: "" }, // type: ST-Stock, IDX-Index, IND-Industry, ...; code:
  //
  popupConfig: { show: false, type: "", code: "" }, // type: ST-Stock, IDX-Index, IND-Industry, ...; code:
  popupTPRLConfig: { show: false, type: "", code: "" }, // type: TPRL; code:
  // Ds nganh
  industries: [],
  // Thong tin chung thi truong
  marketInfos: [],
  //
  findSymbol: { code: "", counter: 0 },
  // Thong so ket noi den server
  concurrentInfo: { time: 0, total: 0, max: 0, current: 0 },
  // Thong so cau hinh an/hien cot tren bang gia
  priceBoardColumnConfig: _initPriceBoardColumnConfig,
  tabNameCurrent: { marketCode: "", indexCode: "", tabName: "", tabNameDisplay: _tabNameCurrentDisplay },
  isLoading: false,
  // category
  listCategory: [],
  categoryStocks: [],
  currentCategory: "",

  // lastSymbol
  lastSymbol: "",

  //
  configShowHideColumn: ["colSubSymbol", "colTotalBuy", "colNNbuy", "colNNsell", "colRoom"],

  configSortColumnMenu: ["symbolColAsc", "symbolColDesc", "totalQttyColAsc", "totalQttyColDesc", "foreignBuyColAsc", "foreignBuyColDesc", "foreignSellColAsc", "foreignSellColDesc"],

  // lưu thông tin search màn "Lịch sử giá" - chi tiết TPRL
  paramSearchHisTPRLPopupDetail: {
    code: '',
    tradingDateFrom: '',
    tradingDateTo: '',
  },
};

export const sharedReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case "ChangeLanguage":
      return {
        ...state,
        language: payload,
      };
    case "ChangeTabRightState":
      return {
        ...state,
        hideTabRight: payload.hidden,
        currentTabRight: payload.tab !== undefined && payload.tab !== null ? payload.tab : state.currentTabRight,
      };
    case "ChangeTabRightMode":
      return {
        ...state,
        tabRightMode: payload,
      };
    case "ChangeTabAutoShow":
      return {
        ...state,
        autoShowOnSelect: payload,
        hideTabRight: payload == false ? true : state.hideTabRight, // Neu k cho auto hien thi dong luon side tab
      };
    case "TabIsFocus":
      return {
        ...state,
        tabIsFocus: payload,
      };
    case "ChangePriceBoardViewMode":
      return {
        ...state,
        priceBoardViewMode: payload,
      };
    case "ChangePriceBoardIndexMode":
      return {
        ...state,
        priceBoardIndexMode: payload,
      };
    case "ChangePriceBoardSortConfig":
      return {
        ...state,
        priceBoardSortConfig: payload,
      };
    case "ChangePriceBoardFavSymbols":
      return {
        ...state,
        priceBoardFavSymbols: payload,
      };
    case "ChangeSummarySymbols":
      return {
        ...state,
        priceBoardSummarySymbols: payload,
      };
    case "GetInfoOfItem":
      return {
        ...state,
        hideTabRight: state.autoShowOnSelect ? false : state.hideTabRight,
        currentTabRight: "INFO",
        getInfoItemCode: payload,
      };
    case "ShowPopupInfo":
      return {
        ...state,
        popupConfig: payload,
      };
    case "HidePopupInfo":
      return {
        ...state,
        popupConfig: { ...state.popupConfig, show: false },
      };
    case "ShowPopupInfoTPRL":
      return {
        ...state,
        popupTPRLConfig: payload,
      };
    case "HidePopupInfoTPRL":
      return {
        ...state,
        popupTPRLConfig: { ...state.popupTPRLConfig, show: false },
      };
    case "InitIndustries":
      return {
        ...state,
        industries: payload,
        initTime: new Date().getTime(),
      };
    case "SetForceUpdateTime":
      return {
        ...state,
        forceUpdateTime: payload,
      };
    case "SetFindSymbol":
      return {
        ...state,
        findSymbol: { code: payload, counter: state.findSymbol.counter + 1 },
      };
    case "RemoveFindSymbol":
      return {
        ...state,
        findSymbol: { code: "", counter: state.findSymbol.counter },
      };
    case "SetServerTime":
      return {
        ...state,
        serverTime: payload,
      };
    case "SetSysParam":
      return {
        ...state,
        sysDate: payload.sysDate,
        startupDate: payload.startupDate,
        tradingDate: payload.tradingDate,
        numberStockTop: isNaN(payload.numberStockTop) === false && Number(payload.numberStockTop) > 0 && Number(payload.numberStockTop),
        sideTab_Type: payload.sideTab_Type,
        sideTab_Code: payload.sideTab_Code,
        useCompanyProfile: payload.useCompanyProfile,
        useDerivative: payload.useDerivative,
      };
    case "UpdateMarketInfos":
      return {
        ...state,
        marketInfos: payload,
      };
    case "SetConcurrentInfo":
      return {
        ...state,
        concurrentInfo: {
          time: payload.time,
          total: payload.total,
          max: payload.max,
          current: payload.current,
        },
      };
    case "SetPriceBoardColumnConfig":
      return {
        ...state,
        priceBoardColumnConfig: payload,
      };
    case "ChangeIsOddlot":
      return {
        ...state,
        priceBoardIsOddlot: payload,
      };
    case "UpdateTabsName":
      return {
        ...state,
        tabNameCurrent: {
          marketCode: payload?.marketCode,
          indexCode: payload?.indexCode,
          tabName: payload?.tabName,
          tabNameDisplay: payload?.tabNameDisplay,
        },
      };
    case "SET_STATUS_LOADING":
      return {
        ...state,
        isLoading: payload,
      };

    case "GET_CATEGORY_STOCK":
      return {
        ...state,
        categoryStocks: payload,
      };
    case "ADD_CATEGORY_STOCK":
      return {
        ...state,
        categoryStocks: [...(state?.categoryStocks ?? {}), payload],
      };
    case "DELETE_CATEGORY_STOCK":
      return {
        ...state,
        categoryStocks: [...state.categoryStocks.filter((e) => e?.id != payload?.id)],
      };
    case "EDIT_CATEGORY_STOCK_NAME":
      return {
        ...state,
        categoryStocks: [
          ...state.categoryStocks.map((e) => {
            if (e?.id === payload?.id) {
              return {
                ...e,
                name: payload?.name,
              };
            }
            return e;
          }),
        ],
      };
    case "SET_CATEGORY_STOCK":
      return {
        ...state,
        currentCategory: payload,
      };

    case "SET_LAST_SYMBOL":
      return {
        ...state,
        lastSymbol: payload,
      };
    case "SET_CONFIG_SHOWHIDE_COLUMN":
      return {
        ...state,
        configShowHideColumn: payload,
      };
    case "SET_CONFIG_SORT_COLUMN_MENU":
      return {
        ...state,
        configSortColumnMenu: payload,
      };
    case "SET_PARAM_SRC_HIS_POPUP_TPRL_DETAIL":
      return {
        ...state,
        paramSearchHisTPRLPopupDetail: {
          ...state.paramSearchHisTPRLPopupDetail,
          code: payload.code ?? state.paramSearchHisTPRLPopupDetail.code,
          tradingDateFrom: payload.tradingDateFrom ?? state.paramSearchHisTPRLPopupDetail.tradingDateFrom,
          tradingDateTo: payload.tradingDateTo ?? state.paramSearchHisTPRLPopupDetail.tradingDateTo,
        },
      };
    default:
      return state;
  }
};
